/* tslint:disable */
/* eslint-disable */

/**
 * 0 = EXW
 * 
 * 1 = CIF
 * 
 * 2 = DAP
 */
export enum Incoterm {
  EXW = 0,
  CIF = 1,
  DAP = 2
}
